import classnames from "classnames";
import React from "react";
import styles from "./AppLogo.module.scss";

/** Логотип приложения: шапка, страница входа и форма заявки агента */
export const AppLogo = ({ className }: AppLogoProps) => {
    return <div className={classnames(styles.logo, "app-logo", className)} />;
};

interface AppLogoProps {
    /** Место, где логотип стоит иначе, чем в шапке — например по центру окна входа */
    className?: string;
}
